"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NThresholdPromoVolume =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NThresholdPromoVolume, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param productExternalId
   * @param promoVolume
   * @param systemVolume
   * @param promoVolumeAbsDiff
   * @param promoVolumeRelDiff
   */
  function NThresholdPromoVolume(productId, productName, productExternalId, promoVolume, systemVolume, promoVolumeAbsDiff, promoVolumeRelDiff) {
    var _this;

    _classCallCheck(this, NThresholdPromoVolume);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NThresholdPromoVolume).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.productExternalId = productExternalId;
    _this.promoVolume = promoVolume;
    _this.systemVolume = systemVolume;
    _this.promoVolumeAbsDiff = promoVolumeAbsDiff;
    _this.promoVolumeRelDiff = promoVolumeRelDiff;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NThresholdPromoVolume, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NThresholdPromoVolume(mat.productId, mat.productName, mat.productExternalId, mat.promoVolume, mat.systemVolume, mat.promoVolumeAbsDiff, mat.promoVolumeRelDiff);
    }
  }]);

  return NThresholdPromoVolume;
}(NotificationDoc_1.NotificationDoc);

exports.NThresholdPromoVolume = NThresholdPromoVolume;

NThresholdPromoVolume.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NThresholdPromoVolume.name);
  return {
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    productExternalId: builder.str('productExternalId'),
    promoVolume: builder.bigNum('promoVolume'),
    systemVolume: builder.bigNum('systemVolume'),
    promoVolumeAbsDiff: builder.bigNum('promoVolumeAbsDiff'),
    promoVolumeRelDiff: builder.bigNum('promoVolumeRelDiff')
  };
}();